<template>
  <div>
    <div class="toolbar">
      <h2>商家管理</h2>
      <el-button type="primary" @click="openForm()">新增</el-button>
    </div>
    <div class="filters">
      <el-input
        v-model="keyword"
        placeholder="搜索名称（中/缅）"
        clearable
        prefix-icon="el-icon-search"
        class="filter-input"
      />
      <el-select
        v-model="filterCityId"
        placeholder="城市"
        class="filter-select"
        @change="onCityFilterChange"
      >
        <el-option label="全部" value="all" />
        <el-option label="待分配" :value="0" />
        <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
      </el-select>
      <el-select
        v-model="filterSubId"
        placeholder="小分类"
        class="filter-select"
      >
        <el-option label="全部" value="all" />
        <el-option label="待分类" :value="0" />
        <el-option v-for="s in subs" :key="s.id" :label="s.name_zh" :value="s.id" />
      </el-select>
      <el-radio-group v-model="sortAsc" size="small">
        <el-radio-button :label="true">正序</el-radio-button>
        <el-radio-button :label="false">倒序</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="!isMobile" class="table-scroll">
    <el-table :data="displayList" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="城市" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.city_name_zh">{{ row.city_name_zh }}</span>
          <el-tag v-else type="warning" size="mini">待分配</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name_zh" label="中文名" />
      <el-table-column label="小分类">
        <template slot-scope="{ row }">
          <span v-if="row.sub_name_zh">{{ row.sub_name_zh }}</span>
          <el-tag v-else type="warning" size="mini">待分类</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="view_count" label="浏览" width="70" />
      <el-table-column prop="sort_order" label="排序" width="70" />
      <el-table-column label="展示" width="80">
        <template slot-scope="{ row }">
          <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
            {{ row.is_active ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openAssign(row)">分配</el-button>
          <el-button type="text" @click="openForm(row)">编辑</el-button>
          <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <MobileCardList
      v-if="isMobile"
      :data="displayList"
      :loading="loading"
      :fields="cardFields"
    >
      <template #sub_name_zh="{ row }">
        <span v-if="row.sub_name_zh">{{ row.sub_name_zh }}</span>
        <el-tag v-else type="warning" size="mini">待分类</el-tag>
      </template>
      <template #is_active="{ row }">
        <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
          {{ row.is_active ? '是' : '否' }}
        </el-tag>
      </template>
      <template #actions="{ row }">
        <el-button type="text" @click="openAssign(row)">分配</el-button>
        <el-button type="text" @click="openForm(row)">编辑</el-button>
        <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
      </template>
    </MobileCardList>

    <el-dialog :title="form.id ? '编辑商家' : '新增商家'" :visible.sync="visible" width="640px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="小分类">
          <el-select
            v-model="form.sub_category_id"
            clearable
            placeholder="留空=待分类"
            style="width:100%"
            @change="onSubChange"
          >
            <el-option v-for="s in formSubs" :key="s.id" :label="subOptionLabel(s)" :value="s.id" />
          </el-select>
          <p class="form-hint">城市跟随小分类（大分类），无需单独选择</p>
        </el-form-item>
        <el-form-item label="中文店名"><el-input v-model="form.name_zh" /></el-form-item>
        <el-form-item label="缅文店名"><el-input v-model="form.name_my" /></el-form-item>
        <el-form-item label="中文描述"><el-input v-model="form.description_zh" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="缅文描述"><el-input v-model="form.description_my" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="详情图 file_id">
          <el-input v-model="form.imageFileId" placeholder="粘贴 Telegram file_id" />
          <div class="tip">向机器人发图，caption 填商家 id（如 12）可获取 file_id</div>
        </el-form-item>
        <el-form-item label="菜单图 file_id">
          <div v-for="(fid, idx) in form.menuFileIds" :key="idx" class="menu-row">
            <el-input v-model="form.menuFileIds[idx]" placeholder="菜单图 file_id" />
            <el-button type="text" style="color:#f56c6c" @click="removeMenuFile(idx)">删除</el-button>
          </div>
          <el-button
            type="text"
            :disabled="form.menuFileIds.length >= 10"
            @click="addMenuFile"
          >
            + 添加菜单图（最多 10 张）
          </el-button>
          <div class="tip">向机器人发图，caption 填 menu:商家id（如 menu:12）</div>
        </el-form-item>
        <el-form-item label="微信号"><el-input v-model="form.wechat" /></el-form-item>
        <el-form-item label="商家频道">
          <el-input v-model="form.channel_username" placeholder="Telegram 频道用户名，不含 @" />
        </el-form-item>
        <el-form-item label="联系商家">
          <el-input v-model="form.telegram_username" placeholder="Telegram 用户名，不含 @，用于详情页按钮" />
        </el-form-item>
        <el-form-item label="电话"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort_order" :min="1" /></el-form-item>
        <el-form-item label="展示"><el-switch v-model="form.is_active" :active-value="1" :inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="分配小分类" :visible.sync="assignVisible" width="440px">
      <el-form label-width="80px">
        <el-form-item label="城市">
          <el-select
            v-model="assignCityId"
            placeholder="选择城市"
            style="width:100%"
            @change="onAssignCityChange"
          >
            <el-option label="待分配" :value="0" />
            <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="大分类">
          <el-select
            v-model="assignMainId"
            placeholder="选择大分类"
            style="width:100%"
            :disabled="assignCityId === null"
            @change="onAssignMainChange"
          >
            <el-option
              v-for="m in assignMains"
              :key="m.id"
              :label="m.name_zh"
              :value="m.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="小分类">
          <el-select
            v-model="assignSubId"
            placeholder="选择小分类"
            style="width:100%"
            :disabled="!assignMainId"
          >
            <el-option
              v-for="s in assignSubs"
              :key="s.id"
              :label="s.name_zh"
              :value="s.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="assignVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!canAssign" @click="onAssign">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from '../api';
import { calcNextSortOrder, filterByKeyword, sortByOrder } from '../utils/listHelpers';
import responsiveMixin from '../mixins/responsive';

const emptyForm = () => ({
  id: null,
  sub_category_id: null,
  main_category_id: null,
  name_zh: '',
  name_my: '',
  description_zh: '',
  description_my: '',
  imageFileId: '',
  menuFileIds: [],
  wechat: '',
  channel_username: '',
  telegram_username: '',
  phone: '',
  sort_order: 1,
  is_active: 1,
});

export default {
  name: 'Merchant',
  mixins: [responsiveMixin],
  data() {
    return {
      list: [],
      subs: [],
      mains: [],
      cities: [],
      loading: false,
      visible: false,
      form: emptyForm(),
      assignVisible: false,
      assignRow: null,
      assignCityId: null,
      assignMainId: null,
      assignSubId: null,
      keyword: '',
      filterCityId: 'all',
      filterSubId: 'all',
      sortAsc: true,
      cardFields: [
        { label: 'ID', prop: 'id' },
        { label: '城市', prop: 'city_name_zh' },
        { label: '中文名', prop: 'name_zh' },
        { label: '小分类', prop: 'sub_name_zh' },
        { label: '浏览', prop: 'view_count' },
        { label: '排序', prop: 'sort_order' },
        { label: '展示', prop: 'is_active' },
      ],
    };
  },
  computed: {
    formSubs() {
      return this.subs;
    },
    assignMains() {
      if (this.assignCityId === null) return [];
      if (this.assignCityId === 0) return this.mains.filter((m) => !m.city_id);
      return this.mains.filter((m) => m.city_id === this.assignCityId);
    },
    assignSubs() {
      if (!this.assignMainId) return [];
      return this.subs.filter((s) => s.main_category_id === this.assignMainId);
    },
    canAssign() {
      return this.assignCityId !== null && Boolean(this.assignMainId) && Boolean(this.assignSubId);
    },
    displayList() {
      let items = filterByKeyword(this.list, this.keyword);
      if (this.filterSubId === 0) {
        items = items.filter((i) => !i.sub_category_id);
      } else if (this.filterSubId !== 'all') {
        items = items.filter((i) => i.sub_category_id === this.filterSubId);
      }
      return sortByOrder(items, this.sortAsc);
    },
  },
  created() {
    this.loadCities();
    this.load();
    this.loadSubs();
    this.loadMains();
  },
  methods: {
    onCityFilterChange() {
      this.filterSubId = 'all';
      this.load();
      this.loadSubs();
    },
    async loadCities() {
      try {
        const { data } = await api.cities.list();
        this.cities = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async loadSubs() {
      try {
        const { data } = await api.subCategories.list();
        this.subs = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async loadMains() {
      try {
        const { data } = await api.mainCategories.list();
        this.mains = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterCityId === 0) params.city_id = 0;
        else if (this.filterCityId !== 'all') params.city_id = this.filterCityId;
        const { data } = await api.merchants.list(params);
        this.list = data;
      } catch (e) {
        this.$message.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    suggestSortOrder(subId) {
      return calcNextSortOrder(this.list, 'sub_category_id', subId ?? null);
    },
    onSubChange(subId) {
      const sub = this.subs.find((s) => s.id === subId);
      this.form.main_category_id = sub?.main_category_id || null;
      if (!this.form.id) {
        this.form.sort_order = this.suggestSortOrder(subId);
      }
    },
    subOptionLabel(s) {
      const city = s.city_name_zh || '待分配';
      return `${s.name_zh}（${city}）`;
    },
    parseMenuFileIds(menuImages) {
      if (!menuImages) return [];
      try {
        const list = typeof menuImages === 'string' ? JSON.parse(menuImages) : menuImages;
        if (!Array.isArray(list)) return [];
        return [...list]
          .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
          .map((item) => item.file_id)
          .filter(Boolean);
      } catch {
        return [];
      }
    },
    addMenuFile() {
      if (this.form.menuFileIds.length >= 10) return;
      this.form.menuFileIds.push('');
    },
    removeMenuFile(idx) {
      this.form.menuFileIds.splice(idx, 1);
    },
    parseImageFileId(images) {
      if (!images) return '';
      try {
        const list = typeof images === 'string' ? JSON.parse(images) : images;
        if (!Array.isArray(list) || !list.length) return '';
        const sorted = [...list].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
        return sorted[0]?.file_id || '';
      } catch {
        return '';
      }
    },
    openAssign(row) {
      this.assignRow = row;
      const subId = row.sub_category_id || null;
      let cityId = null;
      let mainId = null;
      if (subId) {
        const sub = this.subs.find((s) => s.id === subId);
        mainId = sub?.main_category_id ?? null;
        if (mainId) {
          const main = this.mains.find((m) => m.id === mainId);
          cityId = main?.city_id ?? 0;
        }
      }
      this.assignCityId = cityId;
      this.assignMainId = mainId;
      this.assignSubId = subId;
      this.assignVisible = true;
    },
    onAssignCityChange() {
      if (!this.assignMains.some((m) => m.id === this.assignMainId)) {
        this.assignMainId = null;
      }
      if (!this.assignSubs.some((s) => s.id === this.assignSubId)) {
        this.assignSubId = null;
      }
    },
    onAssignMainChange() {
      if (!this.assignSubs.some((s) => s.id === this.assignSubId)) {
        this.assignSubId = null;
      }
    },
    onAssign() {
      if (this.assignCityId === null) {
        this.$message.warning('请选择城市');
        return;
      }
      if (!this.assignMainId) {
        this.$message.warning('请选择大分类');
        return;
      }
      if (!this.assignSubId) {
        this.$message.warning('请选择小分类');
        return;
      }
      const cityLabel = this.assignCityId === 0
        ? '待分配'
        : (this.cities.find((c) => c.id === this.assignCityId)?.name_zh || '');
      const mainName = this.mains.find((m) => m.id === this.assignMainId)?.name_zh || '';
      const subName = this.subs.find((s) => s.id === this.assignSubId)?.name_zh || '';
      this.$confirm(
        `确认将商家「${this.assignRow.name_zh}」分配到「${cityLabel} · ${mainName} · ${subName}」？`,
        '分配确认',
        { type: 'warning' },
      )
        .then(async () => {
          try {
            await api.merchants.assign(this.assignRow.id, this.assignSubId);
            this.$message.success('分配成功');
            this.assignVisible = false;
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
    openForm(row) {
      if (row) {
        this.form = {
          ...row,
          imageFileId: this.parseImageFileId(row.images),
          menuFileIds: this.parseMenuFileIds(row.menu_images),
          channel_username: row.channel_username || '',
          telegram_username: row.telegram_username || '',
          sub_category_id: row.sub_category_id || null,
        };
      } else {
        this.form = {
          ...emptyForm(),
          sort_order: this.suggestSortOrder(null),
        };
      }
      this.visible = true;
    },
    buildPayload() {
      const fileId = this.form.imageFileId.trim();
      const images = fileId ? [{ file_id: fileId, sort: 1 }] : null;
      const menuIds = this.form.menuFileIds
        .map((id) => String(id || '').trim())
        .filter(Boolean)
        .slice(0, 10);
      const menu_images = menuIds.length
        ? menuIds.map((fid, index) => ({ file_id: fid, sort: index + 1 }))
        : null;
      return {
        sub_category_id: this.form.sub_category_id || null,
        main_category_id: this.form.main_category_id || null,
        name_zh: this.form.name_zh,
        name_my: this.form.name_my,
        description_zh: this.form.description_zh,
        description_my: this.form.description_my,
        images,
        menu_images,
        wechat: this.form.wechat,
        channel_username: this.form.channel_username,
        telegram_username: this.form.telegram_username,
        phone: this.form.phone,
        sort_order: this.form.sort_order,
        is_active: this.form.is_active,
      };
    },
    onSubmit() {
      const action = this.form.id ? '保存修改' : '新增';
      this.$confirm(`确认${action}该商家？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            const payload = this.buildPayload();
            if (this.form.id) {
              await api.merchants.update(this.form.id, payload);
            } else {
              await api.merchants.create(payload);
            }
            this.$message.success('操作成功');
            this.visible = false;
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
    onDelete(row) {
      this.$confirm(`确认删除商家「${row.name_zh}」？（逻辑删除）`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确认删除',
        confirmButtonClass: 'el-button--danger',
      })
        .then(async () => {
          try {
            await api.merchants.remove(row.id);
            this.$message.success('已删除');
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.toolbar h2 { margin: 0; }
.filters { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.filter-input { width: 220px; }
.filter-select { width: 180px; }
.tip { font-size: 12px; color: #909399; margin-top: 4px; }
.form-hint { margin: 4px 0 0; font-size: 12px; color: #909399; }
.menu-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.menu-row .el-input { flex: 1; }
</style>
